import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class Institution extends Model<Schemas['institutions'], Models> {}
